module.exports = __webpack_public_path__ + "img/img_internet_start_n.114182bd.png";